import gql from 'graphql-tag';
import * as React from 'react';
import { ChildProps, compose, graphql } from 'react-apollo';

const GetRecommendedProductVariantsQuery = gql`
  query($productID: String!, $country: String) {
    recommendedProducts(productID: $productID, country: $country) {
        id
        order
        productVariant {
            id
            ean
            sku
            definition
            price
            recommendedPrice
            prices
            inStock
            product {
              id
              name
              slug
              price
              prices
              recommendedPrice
              tags
              description
              sku
              display
              status
              weight
              weightForShipping
              visibleForCustomerGroup
              images {
                id
                file
                priority
              }
            }
        }
    }
  }
`;

interface IInputProps {
  children?: any;
  productId: string;
  country?: string;
}

interface IResponse {
  data: any;
}

class RecommendedProductsQuery extends React.PureComponent<ChildProps<IInputProps, IResponse>> {
  public render() {
    const recommendedVariants = (this.props as any).recommendedVariants;
    return this.props.children({
      recommendedVariants
    });
  }
}

// # variants(where: { attributeValues_some: { id_in: $filterValues } }) {

export default compose(
  graphql<IInputProps, IResponse>(GetRecommendedProductVariantsQuery, {
    name: 'recommendedVariants',
    options: props => ({
      variables: {
        productID: props.productId,
        country: props.country
      }
    })
  })
)(RecommendedProductsQuery);


// WEBPACK FOOTER //
// ./src/components/Query/Products/RecommendedProducts.tsx